// extracted by mini-css-extract-plugin
module.exports = {"container":"ii61","authorImageContainer":"nUcf","authorImage":"s-Oi","authorTitle":"MDcj"};